module.exports = __webpack_public_path__ + "img/brands-mivb.2e1c1de2.svg";